module.exports = __webpack_public_path__ + "img/discount-header.64bf0fad.png";